import React from 'react';
import type { BetslipDefault } from '@gin-betting/betslip';
import type { App } from '@gin-betting/core';
import cn from 'classnames';

import './checkListItem.scss';

interface Props {
    changeOddUpdateStatus: BetslipDefault['actions']['changeOddUpdateStatus'];
    oddUpdateStatus: App.OddUpdateStatus;
    label: string;
    isChecked: boolean;
}

const CheckListItem: React.FC<Props> = ({
    isChecked,
    label,
    changeOddUpdateStatus,
    oddUpdateStatus,
}) => {
    const handleChangeOddUpdateStatus = () => {
        if (isChecked) return;

        changeOddUpdateStatus({ oddUpdateStatus });
    };

    return (
        <div
            styleName={cn('container', { checked: isChecked })}
            className="__app-CheckListItem-container"
            onClick={handleChangeOddUpdateStatus}
        >
            <div styleName="radio-wrapper">
                <div styleName={cn('radio', { 'is-active': isChecked })} />
            </div>
            <div styleName="label" className="__app-CheckListItem-label">
                {label}
            </div>
        </div>
    );
};

export default CheckListItem;
